<template>
	<b-modal size="lg" id="invoice-add-modal" title="Inserisci dati fattura" :no-close-on-backdrop="true" hide-footer>
		<div>
			<b-form @submit="add" ref="form" novalidate class="needs-validation">
				<b-row>
					<b-col>
						<b-form-group label="Mese">
							<vue-monthly-picker v-model="month" :monthLabels="monthLabels" :dateFormat="'MMMM YYYY'"
								:clearOption="false" :class="{ err: errorMonth }" />
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<table class="table table-striped">
							<thead>
								<tr>
									<th>Tipo</th>
									<th>Importo</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Energia</td>
									<td><b-form-input v-model="ener" placeholder="Importo" type="number" /></td>
								</tr>
								<tr>
									<td>Dispacciamento</td>
									<td>
										<b-form-input v-model="disp" placeholder="Importo" type="number" />
									</td>
								</tr>
								<tr>
									<td>Spesa trasporto e gestione contatore</td>
									<td>
										<b-form-input v-model="trar" placeholder="Importo" type="number" />
									</td>
								</tr>
								<tr>
									<td>Imposte</td>
									<td>
										<b-form-input v-model="impr" placeholder="Importo" type="number" />
									</td>
								</tr>
							</tbody>
						</table>
					</b-col>
				</b-row>
				<b-row v-if="error">
					<b-col>
						<b-alert :show="!!error" variant="warning">{{ error }}</b-alert>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-btn style="margin-top: 34px" type="submit" variant="primary">Aggiungi</b-btn>
					</b-col>
				</b-row>
			</b-form>
		</div>
	</b-modal>
</template>
<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import moment from 'moment'

export default {
	name: "InvoiceAddModal",
	components: { VueMonthlyPicker },
	data() {
		return {
			error: null,
			month: moment().subtract(1, 'months'),
			errorMonth: false,
			amount: null,
			amountType: null,
			billAuditReportId: null,
			ener: null,
			disp: null,
			trar: null,
			impr: null
		}
	},
	methods: {
		setData(data) {
			this.rows = [...data]
		},
		setBillAuditReportId(id) {
			this.billAuditReportId = id
		},
		async add(e) {
			e.preventDefault()

			if (!this.$refs.form.checkValidity()) {
				this.$refs.form.classList.add('was-validated');
				return;
			}

			if (!this.ener && !this.disp && !this.trar && !this.impr) {
				this.error = "Inserire almeno un importo"
				return
			}

			try {
				const result = await this.$store.dispatch('billaudit/addInvoiceData', {
					billAuditReportId: this.billAuditReportId,
					ener: this.ener,
					disp: this.disp,
					trar: this.trar,
					impr: this.impr,
					monthYear: {
						month: this.month.format('MM'),
						year: this.month.format('YYYY')
					}
				})
				
				this.$notify({
					type: "success",
					title: 'Dati aggiunti',
				});
				this.$emit('created')
			} catch (e) {
				console.log(e)
				this.$notify({
					type: "error",
					title: 'Errore',
				});
			}
		}
	},
	computed: {
		monthLabels() {
			return this.$store.state.utils.monthsShort
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Modals/InvoiceAddModal.vue